import { render } from "./GroupTreeCheckboxParent.vue?vue&type=template&id=20e8c939"
import script from "./GroupTreeCheckboxParent.vue?vue&type=script&lang=js"
export * from "./GroupTreeCheckboxParent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__